import { Injectable } from "@nestjs/common";
import { DataSource, Repository } from "typeorm";
import { PaperMergeEntity } from "../entities/paper-merge.entity";
import { ClassIdRequestModel } from "@boi/shared-models";

@Injectable()
export class PaperMergeRepo extends Repository<PaperMergeEntity> {
    constructor(private dataSource: DataSource) {
        super(PaperMergeEntity, dataSource.createEntityManager());
    }

    async getMergeData(req: ClassIdRequestModel) {
        const result = await this.createQueryBuilder("paperMerge")
            .leftJoinAndSelect("paperMerge.paperMergeChild", "paperMergeChild")
            .where("paperMerge.classId = :classId", { classId: req.classId })
            .orderBy("paperMergeChild.partId", "ASC")   // 👈 order by child
            .getMany();
        return result
    }
}